import React from "react";
import "react-tabs/style/react-tabs.css";

import { useKeycloak } from "@react-keycloak/web";
import { useAtomValue } from "jotai";
import MaterialDiscovery from "../../components/discovery/material-discovery";
import { baseAtom } from "../../stores/jotai/base";
import { useGetCanvasData } from "../../tanstackQuery/queries/canvas";
import { useGetAllFindingLinks } from "../../tanstackQuery/queries/finding-links";
interface Props {
  params?: {
    interviewID?: string;
    artifactID?: string;
    findingID?: string;
  };
  org: OrgState;
  appState: AppState;
  team: TeamState;
  cohort: CohortState;
  user: User;
  note: any;
  findingTypes: any;
  transcript: any;
  teams: TeamsState;
  canvas: ICanvas;
  canvasEntries: CanvasEntryState;
  interviews: Interviews;
  findings: Findings;
  baseAtomBridge: any;
}

const DiscoveryView: React.FC<Props> = (props) => {
  const base = useAtomValue(baseAtom);
  const { keycloak } = useKeycloak();

  const { data: findingLinksData} =
    useGetAllFindingLinks(
      { accessToken: keycloak.token },
      { teamID: base?.team?.id },
      { enabled: !!base?.team?.id }
    );
  const { data: canvasDataAll} =
    useGetCanvasData(
      { accessToken: keycloak.token },
      { groupID: base?.team?.groupID },
      { enabled: !!base?.team?.groupID }
    );

  return (
    <div style={{ height: "100%", width: "100%" }}>
      <MaterialDiscovery
          findingLinksData={findingLinksData}
          canvasDataAll={canvasDataAll}
          {...props}
        />
    </div>
  );
};

export default DiscoveryView;
